module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product7-8b04fd858364a55f0ae428dd7743397e.jpg";